import connect from 'react-redux/es/connect/connect';

import CartPage from './CartPage';
import { removeCartItem } from '../../actions/cart';
import { createGuest } from '../../actions/user';

const mapStateToProps = state => ({
    cartItems: state.cart.cartItems,
    customer: state.user?.customer,
    booker: state.cart.booker,
    user: state.user.user
});

const mapDispatchToProps = dispatch => ({
    removeCartItem: cartItemIndex => {
        dispatch(removeCartItem(cartItemIndex));
    },
    createGuest: (
        firstname,
        lastname,
        phone,
        email,
        additional_emails,
        guest_field_info,
        arrival_date,
        departure_date,
        internal_notes,
        notification,
        source_id,
        onSuccess,
        onError
    ) => {
        dispatch(
            createGuest({
                firstname,
                lastname,
                phone,
                email,
                additional_emails,
                guest_field_info,
                arrival_date,
                departure_date,
                internal_notes,
                notification,
                source_id,
                onSuccess,
                onError
            })
        );
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(CartPage);
